import InputField from "@_common/InputRuleFeild";
import { convertCurrentDateWithTime } from "@_common/date-helpers";
import { handleDownloadOnClick } from "@_common/downloadfile";
import {
  concatDotToDocumentString,
  concatDotToString,
} from "@_common/text-helpers";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import { getFirstLetter } from "@_common/format-text";
import { sanitizeInput } from "@_common/dompurify";

function ComplianceAuditUpdatePopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    selfCompliance,
    setSelfCompliance,
    handleUploadDocuments,
    handleSubmitTask,
    submitLoading,
    selectedStatus,
    selectedObj,
    removeDocument,
    //upload
    handleDrop,
    uploadLoading,
    handleDragOver,
    disableUpload,
  } = props;
  const [complianceStatusList] = useState([
    { value: "POSING", label: "Posing" },
    { value: "PENDING", label: "Pending" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "PENDING_FOR_APPROVAL", label: "Pending For Approval" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    { value: "ASSIGNED", label: "Assigned" },
  ]);
  const [auditStatusList] = useState([
    { value: "OPEN", label: "Open" },
    { value: "PENDING", label: "Pending" },
    { value: "COMPLETED", label: "Completed" },
    { value: "AUTO_COMPLETED", label: "Auto Completed" },
  ]);

  const checkSubmitted = () => {
    return (getValue(selfCompliance, `compliance_status`, "") === "COMPLIED" ||
      getValue(selfCompliance, `compliance_status`, "") === "DELAYED" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "DELAYED_REPORTED") &&
      getValue(selectedObj, `audit_status`, "") === "PENDING"
      ? true
      : false;
  };
  return (
    <div
      className={`compelte-task-wrapper ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">Complete Task</h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>
      <div className="compelte-task-wrapper__body d-flex h-100">
        <div className="compelte-task-wrapper__completion compelte-task-wrapper__completion_fixed_button flex-2 padd-0">
          <div className="complete-task-wrapper__completion-holder">
            <div className="compelte-task-wrapper__common-header">
              <h5 className="compelte-task-wrapper__common-title">
                Task Completion
              </h5>
            </div>
            <div className="compelte-task-wrapper__form">
              <div className="compelte-task-wrapper__form-group mt-0 mb-0 d-flex align-items-center gap">
                <div className="form-group cursor-pointer grid mb-0">
                  <div className="position-relative input-grid-item">
                    <label className="compelte-task-wrapper__label ms-0 fw-bold">
                      Completion Date
                    </label>
                    <label onClick={(e) => e.preventDefault()} className="ms-0">
                      <InputField
                        inputType="DATETYPE-DOB-MODAL"
                        value={getValue(selfCompliance, `completion_date`, "")}
                        className="form-control"
                        onChange={(e: any) =>
                          setSelfCompliance({
                            ...selfCompliance,
                            completion_date: e,
                          })
                        }
                        maxDate={new Date()}
                        placeholderText={"Enter Completion Date"}
                        disabled={true}
                      />
                      <img
                        src="/images/calander.svg"
                        className="img-fluid form-image form-image--calender-modal"
                      />
                    </label>
                  </div>
                </div>
                <div className="d-flex gap position-relative mt-3">
                  <label>
                    <input
                      type="checkbox"
                      className="default-checkbox"
                      checked={getValue(selfCompliance, `event_not_occured`, "")}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          event_not_occured: !getValue(
                            selfCompliance,
                            `event_not_occured`,
                            ""
                          ),
                        })
                      }
                    />
                    <div className="custom-checkbox">
                      <img
                        src="/images/uploaded-details/tick.svg"
                        className="upload-tick img-fluid"
                      />
                    </div>
                  </label>
                  <p>Event did not occur</p>
                </div>
              </div>
              <div className="compelte-task-wrapper__form-group mt-0">
                <label className="compelte-task-wrapper__label">
                  Audit Comments
                </label>
                <textarea
                  placeholder="Enter Evaluator Comments"
                  className="w-100 compelte-task-wrapper__text-area"
                  rows={3}
                  value={getValue(selfCompliance, `auditor_comments`, "")}
                  onChange={(e: any) =>
                    setSelfCompliance({
                      ...selfCompliance,
                      auditor_comments: sanitizeInput(e.target.value),
                    })
                  }
                ></textarea>
              </div>
              <div className="compelte-task-wrapper__form-group">
                {/* <div
                  onDrop={handleDrop}
                  onDragOver={!uploadLoading ? handleDragOver : disableUpload}
                >
                  <p>
                    Files Upload{" 	"}
                    {getValue(
                      selectedObj,
                      `self_compliance.document_required`,
                      ""
                    )
                      ? "*"
                      : ""}
                  </p>
                  <label className="custom-file-upload-popup">
                    {uploadLoading ? (
                      <p>Please wait...</p>
                    ) : (
                      <>
                        <p className="custom-inputfile__attach">
                          Drag & Drop Files here
                        </p>
                        <p className="custom-inputfile__attach">OR</p>
                        <a href="#0">
                          <p className="custom-inputfile__attach">Browse Files</p>
                        </a>
                      </>
                    )}
                    <input
                      type="file"
                      onChange={
                        !uploadLoading ? handleUploadDocuments : disableUpload
                      }
                      multiple
                      className="d-none"
                    />
                  </label>
                </div> */}
                <div className="compelte-task-wrapper__uploaded-files mt-2">
                  <ul>
                    {getValue(selfCompliance, `document_ids`, []).map(
                      (item: any, key: number) => {
                        return (
                          <li
                            className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between cursor-pointer"
                            onClick={() =>
                              handleDownloadOnClick(
                                getValue(item, `url`, ""),
                                getValue(item, `name`, "")
                              )
                            }
                          >
                            <span>
                              {concatDotToDocumentString(
                                getValue(item, `name`, "")
                              )}
                              {getValue(item, `extension`, "")}
                            </span>
                            {/* <img
                              src="/images/close-black.svg"
                              onClick={() =>
                                removeDocument(getValue(item, `id`, ""))
                              }
                            /> */}
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {getValue(props, `permissions`, []).includes("update") ? (
            <>
              {checkSubmitted() ? (
                <div className="compelte-task-wrapper__cta d-flex align-items-center">
                  <button
                    className="ascent-button ascent-button--red"
                    onClick={() => handleSubmitTask("RE_OPENED")}
                    disabled={selectedStatus === "RE_OPENED" && submitLoading}
                  >
                    {selectedStatus === "RE_OPENED" && submitLoading
                      ? "Please wait..."
                      : "Reopen"}
                  </button>
                  <button
                    className="ascent-button ascent-button--orange"
                    onClick={() => handleSubmitTask("NON_COMPLIED")}
                    disabled={
                      selectedStatus === "NON_COMPLIED" && submitLoading
                    }
                  >
                    {selectedStatus === "NON_COMPLIED" && submitLoading
                      ? "Please wait..."
                      : "Non Complied"}
                  </button>
                  <button
                    className="ascent-button ascent-button--green"
                    onClick={() => handleSubmitTask("COMPLETED")}
                    disabled={selectedStatus === "COMPLETED" && submitLoading}
                  >
                    {selectedStatus === "COMPLETED" && submitLoading
                      ? "Please wait..."
                      : "Accept Completed"}
                  </button>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
        <div className="compelte-task-wrapper__response flex-1">
          <div className="compelte-task-wrapper__common-header">
            <h5 className="compelte-task-wrapper__common-title">
              Task Responses
            </h5>
          </div>
          <div className="compelte-task-wrapper__form ">
            <div className="grid">
              <div className="compelte-task-wrapper__form-group input-grid-item">
                <label>Complaince Status</label>
                <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Enter Compliance Status"
                  className="form-control w-100"
                  name="compliance_status"
                  id="compliance_status"
                  value={complianceStatusList.filter(
                    (item: object) =>
                      getValue(item, `value`, "") ===
                      getValue(selfCompliance, `compliance_status`, "")
                  )}
                  options={complianceStatusList}
                  onChange={(e: any) =>
                    setSelfCompliance({
                      ...selfCompliance,
                      compliance_status: e.value,
                    })
                  }
                  label="Compliance Status"
                  disabled
                />
              </div>
            </div>
            <div className="grid">
              <div className="compelte-task-wrapper__form-group input-grid-item">
                <label>Audit Status</label>
                <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Enter Audit Status"
                  className="form-control w-100"
                  name="audit_status"
                  id="audit_status"
                  value={auditStatusList.filter(
                    (item: object) =>
                      getValue(item, `value`, "") ===
                      getValue(selfCompliance, `audit_status`, "")
                  )}
                  options={auditStatusList}
                  onChange={(e: any) =>
                    setSelfCompliance({
                      ...selfCompliance,
                      audit_status: e.value,
                    })
                  }
                  label="Audit Status"
                  disabled
                />
              </div>
            </div>
            <div className="compelte-task-wrapper__form-group">
              {(getValue(selectedObj, `executor_completion_date`, "") ||
                getValue(selfCompliance, `remarks`, "ABC")) && (
                <div className="popup-margin-bottom">
                  <div className="circle">
                    <p className="text">
                      {getFirstLetter(
                        getValue(selectedObj, `executor.first_name`, "")
                      )}
                    </p>
                  </div>
                  <div className="mt-2">
                    <h6 className="compelte-task-wrapper__label_popup ">
                      Executor -{" "}
                      {getValue(selectedObj, `executor.first_name`, "") +
                        " " +
                        getValue(selectedObj, `executor.last_name`, "")}
                    </h6>
                    <p className="subtext_popup mb-3">
                      Updated on{" "}
                      {convertCurrentDateWithTime(
                        getValue(selectedObj, `executor_completion_date`, "")
                      )}
                    </p>
                    <p className="subtext-header mb-1">
                      {getValue(selfCompliance, `remarks`, "")}
                    </p>
                  </div>
                </div>
              )}

              {(getValue(selectedObj, `evaluator_completion_date`, "") ||
                getValue(selectedObj, `evaluator_comments`, "")) && (
                <div className="popup-margin-bottom">
                  <div className="circle">
                    <p className="text">
                      {getFirstLetter(
                        getValue(selectedObj, `evaluator.first_name`, "")
                      )}
                    </p>
                  </div>
                  <div className="mt-2">
                    <h6 className="compelte-task-wrapper__label_popup ">
                      Evaluator -{" "}
                      {getValue(selectedObj, `evaluator.first_name`, "") +
                        " " +
                        getValue(selectedObj, `evaluator.last_name`, "")}
                    </h6>
                    <p className="subtext_popup mb-3">
                      Updated on{" "}
                      {convertCurrentDateWithTime(
                        getValue(selectedObj, `evaluator_completion_date`, "")
                      )}
                    </p>
                    <p className="subtext-header mb-1">
                      {getValue(selectedObj, `evaluator_comments`, "")}
                    </p>
                  </div>
                </div>
              )}

              {
                <>
                  {/* {getValue(selectedObj, `remarks`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                <>
                  {getValue(selectedObj, `evaluator_comments`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label_popup">
                          Evaluator Comments
                        </label>
                        <p>{getValue(selectedObj, `evaluator_comments`, "")}</p>
                      </div>
                    </div>
                  )}
                </>
              }
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label">
                          Remarks
                        </label>
                        <p>{getValue(selfCompliance, `remarks`, "")}</p>
                      </div>
                    </div>
                  )} */}

                  {getValue(selectedObj, `non_compliance_reason`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label_popup">
                          Non Compliance Reason
                        </label>
                        <p className="subtext-header mt-2">
                          {getValue(
                            selfCompliance,
                            `non_compliance_reason`,
                            ""
                          )}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              }
              {/* {
                <>
                  {getValue(selectedObj, `evaluator_comments`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label_popup">
                          Evaluator Comments
                        </label>
                        <p>{getValue(selectedObj, `evaluator_comments`, "")}</p>
                      </div>
                    </div>
                  )}
                </>
              } */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComplianceAuditUpdatePopup;
